import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CorporatePositionDto, CreateCorporatePositionDto } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CorporatePositionsBulkService {
  private readonly baseUrl = '/api/corporate-positions/bulk';
  private readonly http = inject(HttpClient);

  create(
    requestBody: CreateCorporatePositionDto[]
  ): Observable<CorporatePositionDto[]> {
    return this.http.post<CorporatePositionDto[]>(
      `${this.baseUrl}`,
      requestBody
    );
  }

  delete(requestBody: string[]): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}`, { body: requestBody });
  }
}
